export default __webpack_public_path__ + "images/b138d7de-users.svg";